import { OverlayView } from "@react-google-maps/api";

const CustomInfoWindow = ({ position, content }) => {
  const containerStyle = {
    background: 'black',
    color: 'white',
    padding: '0px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.5)',
    fontFamily: 'Arial, sans-serif',
    transform: 'translate(-50%, -100%)', // Konumu biraz yukarı ve ortalamak için
  };

  return (
    <OverlayView
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div style={containerStyle}>
        {content}
      </div>
    </OverlayView>
  );
};


export default CustomInfoWindow